// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".addon-stats{font-size:11px;line-height:12px;opacity:.5}.addon-stats .addon-stats-star{font-size:18px;color:transparent}.addon-stats .addon-stats-star--active{transition:color 1.5s;color:#cccccc}\n", ""]);
// Exports
module.exports = exports;
